<template>
  <div class="record-container">
    <div class="instructions" v-show="!isRecording && !isUploading">Toque para gravar um áudio</div>

    <div class="sending" v-show="isUploading">Enviando áudio...</div>

    <div class="visualizer-container" v-show="isRecording">
      <LottieAnimation
        :animation-data="require('@/assets/audio-waves.json')"
        :auto-play="true"
        :loop="true"
        :speed="1"
        style="height: auto;"
      />
    </div>
    <v-btn v-if="!isRecording && !isUploading" icon @click="startRecording">
      <v-icon large color="#48b38b">mdi-microphone</v-icon>
    </v-btn>
    <v-btn v-if="isRecording" icon @click="stopRecording">
      <v-icon x-large color="red lighten-2">mdi-stop-circle-outline</v-icon>
    </v-btn>
    <v-icon v-if="isUploading" x-large color="blue lighten-2">
      mdi-cloud-upload-outline
    </v-icon>
  </div>
</template>
<script>
import LottieAnimation from "lottie-web-vue"
import ServiceOrderAudioService from '@/services/api/serviceOrderAudio'

export default {
  name: 'AudioRecorder',
  emits: ['audio-uploaded'],
  components: {
    LottieAnimation,
  },
  props: {
    serviceOrderId: {
      type: Number,
      required: true,
    },
    entity: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isRecording: false,
      isUploading: false,
      audioBlob: null,
      audioDuration: null,
    };
  },
  methods: {
    startRecording() {
      if (this.isRecording) return;

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.$toast.error('Gravação não suportada neste navegador.');
        return;
      }

      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
          const audioContext = new (window.AudioContext || window.webkitAudioContext)();
          const source = audioContext.createMediaStreamSource(stream);
          const analyser = audioContext.createAnalyser();

          source.connect(analyser);

          this.mediaRecorder = new MediaRecorder(stream);
          this.mediaRecorder.start();
          this.isRecording = true;

        }).catch(error => console.error('Erro ao acessar o microfone:', error));
    },
    stopRecording() {
      if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
        this.mediaRecorder.ondataavailable = (event) => {
          this.audioBlob = event.data;

          this.uploadAudio();
        };

        this.mediaRecorder.stop();
        this.isRecording = false;
      }
    },
    uploadAudio() {
      if (!this.audioBlob) {
        console.error('No audio to upload');
        return;
      }

      this.isUploading = true;

      const audio = new Audio(URL.createObjectURL(this.audioBlob));

      audio.onloadedmetadata = () => {
        if (audio.duration === Infinity) {
          audio.currentTime = Number.MAX_SAFE_INTEGER;
          audio.ontimeupdate = () => {
            audio.ontimeupdate = null;
            audio.currentTime = 0;
            this.audioDuration = this.formatDuration(audio.duration);
            this.uploadAudioFile();
          };
        } else {
          this.audioDuration = this.formatDuration(audio.duration);
          this.uploadAudioFile();
        }
      };

      audio.onerror = (error) => {
        console.error('Error loading audio:', error);
        this.isUploading = false;
      };
    },
    uploadAudioFile() {
      const formData = new FormData();
      formData.append('file', this.audioBlob, 'audio.wav');
      formData.append('duration', this.audioDuration);

      ServiceOrderAudioService.create(this.serviceOrderId, formData, this.entity)
        .then(response => {
          this.$toast.success('Áudio adicionado com sucesso', {
            position: 'bottom-right'
          });

          this.$emit('audio-uploaded', response.data);
        }).catch(error => {
          console.error('Error uploading audio:', error);
        }).finally(() => {
          this.isUploading = false;
        });
    },
    formatDuration(duration) {
      if (!Number.isFinite(duration)) {
        return "00:00";
      }

      const minutes = Math.floor(duration / 60);
      const seconds = Math.floor(duration % 60);
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .record-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border: 1px dashed rgba(0, 0, 0, 0.4);
    padding: 20px;
    border-radius: 6px;
    position: relative;
    cursor: pointer;
    gap: 12px;
    max-height: 78px;
  }

  .sending,
  .instructions {
    font-size: 14px;
    color: #757575;
  }
</style>
